class ComponentProductGallery extends Theme.Component {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initialize();
    this.events();
  }

  initialize() {
    let options = {
      imagesLoaded: true,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true
    };

    this.slider = new Flickity(this.elements.slider, options);

    this.slider.on("change", (selected_index) => {
      this.playAndPauseVideos(selected_index);
    });

    this.querySelectorAll("video[autoplay]").forEach((video) => {
      video.addEventListener("play", () => {
        video.classList.add("state--playing"), { once: true }
      });
    });
  }

  playAndPauseVideos(selected_index) {
    this.slider.getCellElements().forEach((element, element_index) => {
      const video = element.querySelector("video");

      if (!video) {
        return;
      }

      if (selected_index == element_index) {
        video.play();
      } else {
        video.pause();
      }
    });
  }

  next() {
    this.slider.next();
  }

  previous() {
    this.slider.previous();
  }

  select(detail, target) {
    this.slider.select(detail.index);

    target.classList.add("active--true");

    this.elements.thumbnails.filter((e) => e !== target).forEach((element) => {
      element.classList.remove("active--true");
    });
  }
}

customElements.define("component-product-gallery", ComponentProductGallery);
